export const COMPANY_BY_HOST = {
  'formularz.rolmajster.ideaerp.pl': 1,
  'formularz.karpol.ideaerp.pl': 2
}
